import React, { useState, useEffect } from 'react';
import World from './world.js';
import MapContent from './mapInformation';
import layerdata from '../../data/layers';

import { geoAzimuthalEquidistant } from 'd3-geo';
import styled, { css } from 'styled-components';

const MapCont = styled.svg`
	background: #f8f8f8;
	position: fixed;
	top: 0px;
	left: 0px;
	z-index: 10;
	pointer-events: none;
	height: 100vh;
	width: 100vw;
	${(props) =>
		!props.mobile &&
		css`
			margin-left: 180px;
			width: calc(100vw - 180px);
		`};
`;

const TituloBox = styled.div`
	position: fixed;
	top: 40px;
	left: 220px;
	z-index: 13;
	pointer-events: none;
	${(props) =>
		props.mobile &&
		css`
			top: 60px;
			left: 32px;
		`};
`;

const HCapa = styled.div`
	pointer-events: none;
	font-size: 24px;
	font-weight: 700;
	color: #444;
	letter-spacing: 1px;
	${(props) =>
		props.mobile &&
		css`
			font-size: 18px;
		`};
`;

const HSub = styled.div`
	pointer-events: none;
	font-size: 16px;
	font-weight: normal;
	${(props) =>
		props.mobile &&
		css`
			font-size: 14px;
		`};
`;

const Map = ({ mobile, f, s }) => {
	const p = () => {
		return geoAzimuthalEquidistant()
			.scale(s.level * s.zoomInit)
			.rotate([-s.pos[0], -s.pos[1]])
			.translate([s.size.width / 2, s.size.height / 2]);
	};

	const [layerInfo, setLayerInfo] = useState({ title: 'Network Map', sub: '97 PoPs', sub2: '', sub3: '' });

	useEffect(() => {
		const currentLayer = layerdata.find((el) => el.layer === s.selected.layer);
		if (currentLayer) {
			setLayerInfo({
				title: currentLayer.title,
				sub: currentLayer.sub,
				sub2: currentLayer.sub2,
				sub3: currentLayer.sub3
			});
		}
	}, [s.selected.layer]);

	return (
		<>
			<MapCont id="Map-Container" mobile={mobile}>
				<World p={p} className="base" zoom={s.level * s.zoomInit} move={f.move} />
			</MapCont>
			<TituloBox mobile={mobile}>
				<HCapa mobile={mobile}>{layerInfo.title}</HCapa>
				<HSub mobile={mobile}>
					{layerInfo.sub3 !== '' ? (
						<>
							{layerInfo.sub} <br /> {layerInfo.sub2} <br /> {layerInfo.sub3}
						</>
					) : layerInfo.sub2 !== '' ? (
						<>
							{layerInfo.sub} <br /> {layerInfo.sub2}
						</>
					) : (
						layerInfo.sub
					)}
				</HSub>
			</TituloBox>
			<MapContent f={f} mobile={mobile} state={s} />
		</>
	);
};

export default Map;
